<script setup lang="ts"></script>

<template>
  <div class="min-h-screen bg-slate-100 py-12 antialiased">
    <slot />
  </div>
</template>
